module.exports = __webpack_public_path__ + "img/round-right-iconB.0c9f5542.svg";